import { IUserGroupPermission, RolesType } from 'api/api';
import { hasAtLeast } from 'utilities/roles-util';
import { AuthPageRequirement } from './auth-requirements';

export const authPermissionCheck = (
	userGroupPermissions: IUserGroupPermission[],
	authPageRequirement: AuthPageRequirement,
	hasSubscription: boolean = true
): boolean => {
	// User must parse one of these validations
	return (
		((authPageRequirement.minRole &&
			userGroupPermissions.some(usr => hasAtLeast(usr.roleType, authPageRequirement.minRole!))) || // User has at least minRole
		(authPageRequirement.exactRoles?.length &&
			userGroupPermissions.some(usr => authPageRequirement.exactRoles!.includes(usr.roleType))) || // At least one role within the list of exactRoles
			(!!authPageRequirement.isPartnerArea && userGroupPermissions.some(usr => usr.isPartnerArea))) && // User isPartnerArea
		(!authPageRequirement.blockIfNoSubscription ||
			hasSubscription ||
			userGroupPermissions.some(usr => usr.roleType === RolesType.SuperAdmin || usr.isPremium)) // No subscription block
	);
};
